// vendor modules
import React from "react"
import PropTypes from "prop-types"

// components
import { SelectableSubheader, Icon } from "quorumdesign"
import { Tooltip } from "@quorumus/plum"

import * as constants from "app/static/frontend/design-constants"
import { useResponsiveSize } from "@/hooks"

const FilterHeader = (props) => {
    const { isMobile } = useResponsiveSize()

    if (
        props.searchFilterTerm &&
        props.label &&
        props.label.toString().toLowerCase().includes(props.searchFilterTerm.toLowerCase())
    ) {
        if (props.setFilterGroupContainsSearchFilterTerm) {
            props.setFilterGroupContainsSearchFilterTerm(true)
        } else {
            // not marked required
            console.error(
                `Missing props.setFilterGroupContainsSearchFilterTerm — ${props.searchFilterTerm} contained in "${props.label}".`,
            )
        }
        if (props.setFilterHeaderContainsSearchFilterTerm) {
            props.setFilterHeaderContainsSearchFilterTerm(true)
        } else {
            // not marked required
            console.error(
                `Missing props.setFilterHeaderContainsSearchFilterTerm — ${props.searchFilterTerm} contained in "${props.label}".`,
            )
        }
    }

    if (props.helpText != null) {
        return (
            // Subheader with tooltip + no "select all" checkbox
            <SelectableSubheader
                invisible={props.invisible}
                searchFilterTerm={props.searchFilterTerm}
                title={props.label}
            >
                {!isMobile && (
                    <Tooltip label={props.helpText} position="top" withinPortal={false}>
                        <Icon icon="info-circle" iconFamily="far" color={constants.QuorumGrey4} />
                    </Tooltip>
                )}
            </SelectableSubheader>
        )
    }

    return (
        // Subheader with no tooltip + no "select all" checkbox
        <SelectableSubheader
            invisible={props.invisible}
            searchFilterTerm={props.searchFilterTerm}
            title={props.label}
        />
    )
}

export default FilterHeader

FilterHeader.propTypes = {
    label: PropTypes.string,
    isActive: PropTypes.bool,
    helpText: PropTypes.string,
    // selected from the search => props.uniqueFlvId slice of the store
    searchFilterTerm: PropTypes.string,
    // from app/static/frontend/search-new/components/Filter/index.js
    setFilterHeaderContainsSearchFilterTerm: PropTypes.func,
    // from app/static/frontend/search-new/components/FilterGroup/index.js renderFilters
    setFilterGroupContainsSearchFilterTerm: PropTypes.func,
}
